import React from "react";
import { AEFile } from "../../../../../../_metronic/_partials/controls";
import { useIntl } from "react-intl";

const Voucher = ({ _props }) => {
  const {formatMessage} = useIntl();
  return (
    <div>
      {/* <h1>Upload your cash receipt</h1> */}
      <div className="form-group row py-1">
        <label htmlFor="">{formatMessage({id:"CASH.UPLOAD"})}</label>
        <div className={"col-lg-12"}>
          <AEFile
            {..._props("attachments", "ATTACHMENTS")}
            accept={"image/*"}
          />
        </div>
      </div>
    </div>
  );
};

export default Voucher;
